import Picker from './src/picker';
import DatePanel from './src/panel/date';
import DateRangePanel from './src/panel/date-range';
import MonthRangePanel from './src/panel/month-range';
import YearRangePanel from './year-range';

const getPanel = function(type) {
  if (type === 'daterange' || type === 'datetimerange') {
    return DateRangePanel;
  } else if (type === 'monthrange') {
    return MonthRangePanel;
  } else if (type === 'yearrange') {
    return YearRangePanel;
  }
  return DatePanel;
};

export default {
  mixins: [Picker],

  name: 'DatePicker',

  props: {
    type: {
      type: String,
      default: 'date'
    },
    timeArrowControl: Boolean
  },

  watch: {
    type(type) {
      if (this.picker) {
        this.unmountPicker();
        this.panel = getPanel(type);
        this.mountPicker();
      } else {
        this.panel = getPanel(type);
      }
    }
  },

  created() {
    this.panel = getPanel(this.type);
  }
};



// WEBPACK FOOTER //
// ./src/components/common/el/date-picker/index.js